import type { Layout } from "react-grid-layout"

import { SPAN_LAYOUT_MAP } from "helpers/config/dashboards/powerline/defs"

export const powerlineInfoTabLayoutLg: Record<string, Layout> = {
  [SPAN_LAYOUT_MAP]: {
    w: 12,
    h: 0,
    x: 0,
    y: 0,
    minH: 0,
    i: SPAN_LAYOUT_MAP,
  },
  LONG_TERM_AMPACITY: {
    w: 12,
    h: 3,
    x: 0,
    y: 5,
    minH: 0,
    i: "LONG_TERM_AMPACITY",
  },
  LAST_AMPACITY_AAR: {
    w: 3.5,
    h: 1.5,
    x: 0,
    y: 8,
    minH: 0,
    i: "LAST_AMPACITY_AAR",
  },
  LAST_AMPACITY_DLR: {
    w: 3.5,
    h: 1.5,
    x: 3.5,
    y: 8,
    minH: 0,
    i: "LAST_AMPACITY_DLR",
  },
  BELOW_NOMINAL_AMPACITY: {
    w: 5,
    h: 1.5,
    x: 7,
    y: 8,
    minH: 0,
    i: "BELOW_NOMINAL_AMPACITY",
  },
  SHORT_TERM_AMPACITY: {
    w: 7,
    h: 3,
    x: 0,
    y: 9.5,
    minH: 0,
    i: "SHORT_TERM_AMPACITY",
  },
  ACTIVE_SHORT_TERM_AMPACITY: {
    w: 5,
    h: 3,
    x: 7,
    y: 9.5,
    minH: 0,
    i: "ACTIVE_SHORT_TERM_AMPACITY",
  },
  CURRENT: {
    w: 9,
    h: 3,
    x: 0,
    y: 12.5,
    minH: 0,
    i: "CURRENT",
  },
  LAST_CURRENT: {
    w: 3,
    h: 3,
    x: 9,
    y: 12.5,
    minH: 0,
    i: "LAST_CURRENT",
  },
}
